export default __webpack_public_path__ + "static/media/Poppins-ExtraBold.01849ee0.woff";